import React, { useEffect, useState } from "react";
import { PGET } from "../../../api/adminApi";
import CustomDatePicker from "../../common/CustomDatePicker/CustomDatePicker";
import moment from "moment";

export default function RoyalTopMasters() {
  const [items, setItems] = useState([]);
  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [startDate, endDate] = dateRange;

  async function getItems() {
    if (startDate && endDate) {
      const data = await PGET(
        "/services/admin/api/royal/dashboard-topten-masters/",
        true,
        {
          dateFrom: moment(startDate).format("YYYY-MM-DD"),
          dateTo: moment(endDate).add(1, "day").format("YYYY-MM-DD"),
          orderById: 0,
        }
      );
      if (data) {
        setItems(data.data);
      }
    }
  }

  useEffect(() => {
    getItems();
  }, [startDate, endDate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ minHeight: 400 }}>
      <div style={{ display: "flex" }}>
        <div style={{ width: 200, position: "absolute", right: 10, top: 20 }}>
          <CustomDatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => {
              setDateRange(update);
            }}
            isClearable={true}
            dateFormat="dd.MM.yyyy"
            className="datepicker-custom-input"
          />
        </div>

      </div>
      <div style={{ overflowX: "auto" }}>
        <table
          className="table bg-white table-rounded table-striped"
          style={{ fontSize: 12 }}
        >
          <thead>
            <tr className="fw-bold text-gray-800 border-bottom-2 border-gray-200">
              <th style={{ width: "5%" }} className="text-center">
                №
              </th>
              <th style={{ width: "20%" }} className="text-start">
                ФИО
              </th>
              <th style={{ width: "10%" }} className="text-start">
                Регион
              </th>
              <th style={{ width: "10%" }} className="text-center">
                Общий
              </th>
            </tr>
          </thead>

          <tbody style={{ overflowX: "auto" }}>
            {items.map((item, index) => {
              return (
                <tr key={item.soldUserId}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-start">{item.soldMasterName}</td>
                  <td className="text-start">{item.regionName}</td>
                  <td className="text-center">{item.soldCount}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
